
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Base } from '~/core/Base'

@Component
export default class CSVPreview extends Base {
  @Prop() csv!: string[][]

  @Prop({ default: 100 }) itemsPerPage!: number

  page: number = 1

  get columnNames(): string[] {
    return this.csv.length ? this.csv[0] : []
  }

  get rows(): string[][] {
    return this.csv.length > 1 ? this.csv.slice(1) : []
  }

  get pageCount(): number {
    return Math.ceil(this.rows.length / this.itemsPerPage)
  }

  get pagedRows(): string[][] {
    return this.rows.slice(this.startIndex, this.endIndex)
  }

  get startIndex(): number {
    return (this.page - 1) * this.itemsPerPage
  }

  get endIndex(): number {
    return Math.min(this.startIndex + this.itemsPerPage, this.rows.length)
  }

}
